import { useTranslation } from '@/lib/i18n/react';
import { typingParts } from '../dock-presence';

/** Product grammar follows the personal language; names stay literal and isolated. */
export function ChatTypingLabel({ names }: { names: string[] }) {
  useTranslation('teamchat');
  return <>{typingParts(names).map((part, index) => 'name' in part
    ? <b key={index}><bdi dir="auto">{part.name}</bdi></b>
    : part.text)}</>;
}
